import ThFormContainer from 'components/th/ThFormContainer';

export default function ThMigrationFormPage() {
  const contentfulId = '5xq2uLRZqvzRrLiATD5fOS'; // Korea Form Page
  const country = 'THAILAND';
  return <ThFormContainer contentfulId={contentfulId} country={country} />;
}
